<header>
  <div class="header-content">
    <div class="header-left">
      <a class="logo-link" href="https://insights.axpo.com">
        <div class="logo-container">
          <axpo-logo />
        </div>
        <div class="divider"></div>
        <div class="title">Insights</div>
      </a>
    </div>
    <div class="header-center">
      <a href="https://insights.axpo.com">Home</a>
      <i class="bi bi-chevron-right text-xs"></i>
      <a href="https://insights.axpo.com/modules/3d">Digital Twins</a>
    </div>
    <div class="header-right">
      <app-profile-dropdown />
    </div>
  </div>
</header>
